/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Smartphone';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const SmartphoneIcon = withMuiAdapter(Base, 'Smartphone');
